export default __webpack_public_path__ + "static/media/vc.7306540a.svg";